export default __webpack_public_path__ + "static/media/interrogation.19393dad.svg";